import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function submitConsultation(payload) {
  const res = await axios.post(`${API}/consultation`, payload);
  return res.data;
}

export async function submitLeadMagnet(payload) {
  const res = await axios.post(`${API}/lead-magnet`, payload);
  return res.data;
}
